var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"ご購入完了","description":"ご購入頂き、ありがとうございます。早速購入した設問を解いてみましょう。","to":_vm.content,"buttonText":"コンテンツページに戻る"}})}
var staticRenderFns = []

export { render, staticRenderFns }